// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Today's training session cards — home coach/admin strip */

.hts {
  --hts-ink: var(--text-color, #0f172a);
  --hts-muted: var(--text-secondary, #64748b);
  --hts-surface: var(--surface-color, #ffffff);
  --hts-border: var(--border-color, #e2e8f0);
  --hts-soft: color-mix(in srgb, var(--hts-ink) 4%, var(--hts-surface));
  --hts-brand: var(--brand-primary, #0877bc);
  --hts-rail: var(--hts-brand);
  position: relative;
  z-index: 2;
  isolation: isolate;
  margin: 2px 8px;
  width: auto;
  max-width: 100%;
  box-sizing: border-box;
}

.hts .metrics {
  margin: 0;
}

.hts__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.hts__head > h3 {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hts__count {
  flex: 0 0 auto;
  margin: 0;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: var(--brand-primary, #0877bc);
  white-space: nowrap;
}

.hts__empty,
.hts__loading {
  margin: 8px 4px 0;
  padding: 22px 16px;
  text-align: center;
  border-radius: 16px;
  border: 1px dashed var(--hts-border);
  background: var(--hts-soft);
  color: var(--hts-muted);
  font-size: 0.9rem;
  font-weight: 600;
}

.hts__track {
  display: flex;
  width: 100%;
  padding: 0 2px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  overscroll-behavior-x: contain;
}

.hts__track::-webkit-scrollbar {
  display: none;
}

.hts__slide {
  /* Desktop: three cards per screen (matches groups strip) */
  flex: 0 0 33.333%;
  min-width: 0;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  box-sizing: border-box;
}

.hts-card {
  position: relative;
  display: grid;
  grid-template-columns: 4px 1fr auto;
  align-items: stretch;
  gap: 0;
  /* Coach card height, sized for 3-up horizontal strip on desktop */
  min-height: 148px;
  height: 148px;
  margin: 8px 4px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid var(--hts-border);
  background:
    radial-gradient(
      120% 90% at 0% 0%,
      color-mix(in srgb, var(--hts-brand) 14%, transparent),
      transparent 55%
    ),
    linear-gradient(
      155deg,
      var(--hts-surface) 0%,
      color-mix(in srgb, var(--hts-brand) 6%, var(--hts-surface)) 100%
    );
  box-shadow: 0 8px 22px color-mix(in srgb, var(--hts-brand) 14%, transparent);
  color: var(--hts-ink);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.hts-card:hover,
.hts-card:focus-visible {
  transform: translateY(-2px);
  box-shadow: 0 14px 34px color-mix(in srgb, var(--hts-brand) 22%, transparent);
  border-color: color-mix(in srgb, var(--hts-brand) 35%, var(--hts-border));
  outline: none;
}

.hts-card:active {
  transform: translateY(0);
}

.hts-card--active {
  border-color: color-mix(in srgb, var(--hts-brand) 55%, var(--hts-border));
  box-shadow:
    0 0 0 2px color-mix(in srgb, var(--hts-brand) 28%, transparent),
    0 14px 34px color-mix(in srgb, var(--hts-brand) 20%, transparent);
}

.hts-card--running {
  --hts-rail: #22c55e;
}

.hts-card--paused {
  --hts-rail: #f59e0b;
}

.hts-card--finalized {
  --hts-rail: #ef4444;
}

.hts-card--scheduled {
  --hts-rail: var(--hts-brand);
}

.hts-card__rail {
  background: linear-gradient(
    180deg,
    var(--hts-rail),
    color-mix(in srgb, var(--hts-rail) 55%, #0f172a)
  );
}

.hts-card--running .hts-card__rail {
  animation: hts-rail-pulse 1.8s ease-in-out infinite;
}

@keyframes hts-rail-pulse {
  0%,
  100% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.25);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hts-card--running .hts-card__rail {
    animation: none;
  }

  .hts-card {
    transition: none;
  }
}

.hts-card__body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
  padding: 10px 8px 10px 10px;
}

.hts-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.hts-card__when {
  min-width: 0;
}

.hts-card__time {
  display: block;
  font-family: Poppins, system-ui, sans-serif;
  font-size: clamp(1.05rem, 3.4vw, 1.35rem);
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--hts-ink);
}

.hts-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-top: 2px;
  min-width: 0;
}

.hts-card__duration {
  font-size: 0.65rem;
  font-weight: 700;
  color: var(--hts-brand);
  white-space: nowrap;
}

.hts-card__date {
  font-size: 0.65rem;
  font-weight: 600;
  color: var(--hts-muted);
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.hts-card__status {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 42%;
  padding: 3px 6px;
  border-radius: 999px;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: color-mix(in srgb, var(--hts-rail) 16%, var(--hts-surface));
  color: color-mix(in srgb, var(--hts-rail) 75%, var(--hts-ink));
  border: 1px solid color-mix(in srgb, var(--hts-rail) 32%, transparent);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hts-card--running .hts-card__status::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--hts-rail);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--hts-rail) 28%, transparent);
}

.hts-card__title {
  margin: 0;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.2;
  color: var(--hts-ink);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hts-card__group {
  margin: 2px 0 0;
  font-size: 0.65rem;
  font-weight: 650;
  color: var(--hts-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hts-card__players {
  display: flex;
  align-items: center;
  min-height: 26px;
}

.hts-card__avatar,
.hts-card__avatar-fallback {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--hts-surface);
  object-fit: cover;
  margin-left: -6px;
  flex-shrink: 0;
  position: relative;
  background: var(--hts-brand);
}

.hts-card__avatar:first-child,
.hts-card__avatar-fallback:first-child {
  margin-left: 0;
}

.hts-card__avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
}

.hts-card__more {
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 750;
  color: var(--hts-brand);
  background: color-mix(in srgb, var(--hts-brand) 10%, var(--hts-surface));
  border: 1px solid color-mix(in srgb, var(--hts-brand) 28%, transparent);
}

.hts-card__players-empty {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--hts-muted);
}

.hts-card__aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 8px 6px 8px 0;
  color: var(--hts-muted);
}

.hts-card__go {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: color-mix(in srgb, var(--hts-brand) 12%, var(--hts-surface));
  color: var(--hts-brand);
  border: 1px solid color-mix(in srgb, var(--hts-brand) 22%, transparent);
  transition: background 0.15s ease, transform 0.15s ease;
}

.hts-card:hover .hts-card__go,
.hts-card:focus-visible .hts-card__go {
  background: var(--hts-brand);
  color: #fff;
  transform: translateX(2px);
}

.hts-card__register {
  margin-top: 4px;
  padding: 6px 10px;
  border: none;
  border-radius: 10px;
  background: var(--hts-brand);
  color: #fff;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.hts-card__hr {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.65rem;
  font-weight: 650;
  color: var(--hts-muted);
  text-align: right;
}

.dark-mode .hts-card,
html[data-theme="dark"] .hts-card {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
}

@media (max-width: 999px) {
  /* One card per screen with mandatory snap scroll on mobile */
  .hts__slide {
    flex: 0 0 100%;
  }

  .hts-card {
    margin: 6px 2px;
    min-height: 148px;
    height: 148px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TodaySessions.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,4CAA4C;EAC5C,0CAA0C;EAC1C,qEAAqE;EACrE,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,oBAAoB;EACpB,MAAM;EACN,kEAAkE;EAClE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC;;;;;;;;;;KAUG;EACH,4EAA4E;EAC5E,qBAAqB;EACrB;;;0BAGwB;EACxB,wCAAwC;AAC1C;;AAEA;;EAEE,2BAA2B;EAC3B,6EAA6E;EAC7E,yEAAyE;EACzE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yEAAyE;EACzE;;qEAEmE;AACrE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;;IAEE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uEAAuE;EACvE,8DAA8D;EAC9D,sEAAsE;EACtE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wEAAwE;EACxE,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wEAAwE;EACxE,uBAAuB;EACvB,uEAAuE;EACvE,uDAAuD;AACzD;;AAEA;;EAEE,4BAA4B;EAC5B,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;AACF","sourcesContent":["/* Today's training session cards — home coach/admin strip */\n\n.hts {\n  --hts-ink: var(--text-color, #0f172a);\n  --hts-muted: var(--text-secondary, #64748b);\n  --hts-surface: var(--surface-color, #ffffff);\n  --hts-border: var(--border-color, #e2e8f0);\n  --hts-soft: color-mix(in srgb, var(--hts-ink) 4%, var(--hts-surface));\n  --hts-brand: var(--brand-primary, #0877bc);\n  --hts-rail: var(--hts-brand);\n  position: relative;\n  z-index: 2;\n  isolation: isolate;\n  margin: 2px 8px;\n  width: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.hts .metrics {\n  margin: 0;\n}\n\n.hts__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.hts__head > h3 {\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hts__count {\n  flex: 0 0 auto;\n  margin: 0;\n  font-family: Poppins, system-ui, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 22px;\n  color: var(--brand-primary, #0877bc);\n  white-space: nowrap;\n}\n\n.hts__empty,\n.hts__loading {\n  margin: 8px 4px 0;\n  padding: 22px 16px;\n  text-align: center;\n  border-radius: 16px;\n  border: 1px dashed var(--hts-border);\n  background: var(--hts-soft);\n  color: var(--hts-muted);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.hts__track {\n  display: flex;\n  width: 100%;\n  padding: 0 2px;\n  box-sizing: border-box;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  overscroll-behavior-x: contain;\n}\n\n.hts__track::-webkit-scrollbar {\n  display: none;\n}\n\n.hts__slide {\n  /* Desktop: three cards per screen (matches groups strip) */\n  flex: 0 0 33.333%;\n  min-width: 0;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  box-sizing: border-box;\n}\n\n.hts-card {\n  position: relative;\n  display: grid;\n  grid-template-columns: 4px 1fr auto;\n  align-items: stretch;\n  gap: 0;\n  /* Coach card height, sized for 3-up horizontal strip on desktop */\n  min-height: 148px;\n  height: 148px;\n  margin: 8px 4px;\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 1px solid var(--hts-border);\n  background:\n    radial-gradient(\n      120% 90% at 0% 0%,\n      color-mix(in srgb, var(--hts-brand) 14%, transparent),\n      transparent 55%\n    ),\n    linear-gradient(\n      155deg,\n      var(--hts-surface) 0%,\n      color-mix(in srgb, var(--hts-brand) 6%, var(--hts-surface)) 100%\n    );\n  box-shadow: 0 8px 22px color-mix(in srgb, var(--hts-brand) 14%, transparent);\n  color: var(--hts-ink);\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease,\n    border-color 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.hts-card:hover,\n.hts-card:focus-visible {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 34px color-mix(in srgb, var(--hts-brand) 22%, transparent);\n  border-color: color-mix(in srgb, var(--hts-brand) 35%, var(--hts-border));\n  outline: none;\n}\n\n.hts-card:active {\n  transform: translateY(0);\n}\n\n.hts-card--active {\n  border-color: color-mix(in srgb, var(--hts-brand) 55%, var(--hts-border));\n  box-shadow:\n    0 0 0 2px color-mix(in srgb, var(--hts-brand) 28%, transparent),\n    0 14px 34px color-mix(in srgb, var(--hts-brand) 20%, transparent);\n}\n\n.hts-card--running {\n  --hts-rail: #22c55e;\n}\n\n.hts-card--paused {\n  --hts-rail: #f59e0b;\n}\n\n.hts-card--finalized {\n  --hts-rail: #ef4444;\n}\n\n.hts-card--scheduled {\n  --hts-rail: var(--hts-brand);\n}\n\n.hts-card__rail {\n  background: linear-gradient(\n    180deg,\n    var(--hts-rail),\n    color-mix(in srgb, var(--hts-rail) 55%, #0f172a)\n  );\n}\n\n.hts-card--running .hts-card__rail {\n  animation: hts-rail-pulse 1.8s ease-in-out infinite;\n}\n\n@keyframes hts-rail-pulse {\n  0%,\n  100% {\n    filter: brightness(1);\n  }\n  50% {\n    filter: brightness(1.25);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hts-card--running .hts-card__rail {\n    animation: none;\n  }\n\n  .hts-card {\n    transition: none;\n  }\n}\n\n.hts-card__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 6px;\n  min-width: 0;\n  padding: 10px 8px 10px 10px;\n}\n\n.hts-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.hts-card__when {\n  min-width: 0;\n}\n\n.hts-card__time {\n  display: block;\n  font-family: Poppins, system-ui, sans-serif;\n  font-size: clamp(1.05rem, 3.4vw, 1.35rem);\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  color: var(--hts-ink);\n}\n\n.hts-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 8px;\n  margin-top: 2px;\n  min-width: 0;\n}\n\n.hts-card__duration {\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: var(--hts-brand);\n  white-space: nowrap;\n}\n\n.hts-card__date {\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: var(--hts-muted);\n  text-transform: capitalize;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.hts-card__status {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 42%;\n  padding: 3px 6px;\n  border-radius: 999px;\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  background: color-mix(in srgb, var(--hts-rail) 16%, var(--hts-surface));\n  color: color-mix(in srgb, var(--hts-rail) 75%, var(--hts-ink));\n  border: 1px solid color-mix(in srgb, var(--hts-rail) 32%, transparent);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hts-card--running .hts-card__status::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--hts-rail);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--hts-rail) 28%, transparent);\n}\n\n.hts-card__title {\n  margin: 0;\n  font-family: Poppins, system-ui, sans-serif;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 1.2;\n  color: var(--hts-ink);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.hts-card__group {\n  margin: 2px 0 0;\n  font-size: 0.65rem;\n  font-weight: 650;\n  color: var(--hts-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hts-card__players {\n  display: flex;\n  align-items: center;\n  min-height: 26px;\n}\n\n.hts-card__avatar,\n.hts-card__avatar-fallback {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--hts-surface);\n  object-fit: cover;\n  margin-left: -6px;\n  flex-shrink: 0;\n  position: relative;\n  background: var(--hts-brand);\n}\n\n.hts-card__avatar:first-child,\n.hts-card__avatar-fallback:first-child {\n  margin-left: 0;\n}\n\n.hts-card__avatar-fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.hts-card__more {\n  margin-left: 6px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 750;\n  color: var(--hts-brand);\n  background: color-mix(in srgb, var(--hts-brand) 10%, var(--hts-surface));\n  border: 1px solid color-mix(in srgb, var(--hts-brand) 28%, transparent);\n}\n\n.hts-card__players-empty {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--hts-muted);\n}\n\n.hts-card__aside {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 8px 6px 8px 0;\n  color: var(--hts-muted);\n}\n\n.hts-card__go {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--hts-brand) 12%, var(--hts-surface));\n  color: var(--hts-brand);\n  border: 1px solid color-mix(in srgb, var(--hts-brand) 22%, transparent);\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.hts-card:hover .hts-card__go,\n.hts-card:focus-visible .hts-card__go {\n  background: var(--hts-brand);\n  color: #fff;\n  transform: translateX(2px);\n}\n\n.hts-card__register {\n  margin-top: 4px;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 10px;\n  background: var(--hts-brand);\n  color: #fff;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.hts-card__hr {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 0.65rem;\n  font-weight: 650;\n  color: var(--hts-muted);\n  text-align: right;\n}\n\n.dark-mode .hts-card,\nhtml[data-theme=\"dark\"] .hts-card {\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);\n}\n\n@media (max-width: 999px) {\n  /* One card per screen with mandatory snap scroll on mobile */\n  .hts__slide {\n    flex: 0 0 100%;\n  }\n\n  .hts-card {\n    margin: 6px 2px;\n    min-height: 148px;\n    height: 148px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
